import React from "react";
import { IoChevronDownSharp } from "react-icons/io5";

import {
  EMPTY_STRING,
  PAYLOAD_KEYS,
  propertySortingSelectOptions,
} from "../../../constants";
import SearchField from "../search/SearchField";

const { SEARCH, ORDER_BY } = PAYLOAD_KEYS;

const PropertyFilter = ({
  allCountries = [],
  searchValue = EMPTY_STRING,
  countryValue = EMPTY_STRING,
  orderByValue = EMPTY_STRING,
  onResetFilters,
  onFilterChange,
  onCountryChange,
  searchPlaceHolder = EMPTY_STRING,
}) => {
  return (
    <div className="d-flex flex-wrap flex-column flex-lg-row column-gap-4 align-items-lg-center">
      <SearchField
        className="d-inline-block width-fit-content"
        value={searchValue}
        handleSearch={(val) => onFilterChange(val, SEARCH)}
        placeholder={searchPlaceHolder}
      />
      <div className="d-flex flex-wrap column-gap-4 align-items-center">
        {/* Country Dropdown */}
        <div className="position-relative select-field">
          <select
            className="mt-4 select-field-country"
            value={countryValue}
            onChange={(e) => onCountryChange(e.target.value)}
          >
            <option value={EMPTY_STRING}>Country</option>
            {allCountries.map((option) => (
              <option key={option.id} value={`countryId=${option.id}`}>
                {option.name}
              </option>
            ))}
          </select>
          <IoChevronDownSharp className="mt-4" />
        </div>
        {/* Sorting Dropdown */}
        <div className="position-relative select-field">
          <select
            className="mt-4 select-field-sort"
            value={orderByValue}
            onChange={(e) => onFilterChange(e.target.value, ORDER_BY)}
          >
            <option value={EMPTY_STRING}>Sort By</option>
            {propertySortingSelectOptions.map((option) => (
              <option key={option.id} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <IoChevronDownSharp className="mt-4" />
        </div>
        {/* Reset Filter */}
        <div className="mt-5 reset-filter" onClick={() => onResetFilters()}>
          Reset Filter
        </div>
      </div>
    </div>
  );
};

export default React.memo(PropertyFilter);
